import React from "react";
import { Table, Container } from "react-bootstrap";

const Tabble = ({ className, data, columns }) => {
    return (
        <Container fluid>
            <div className="table-responsive">
                <Table className={className}>
                    <thead className="tabble-thead">
                        <tr className="thead-tr">
                            {columns?.map((column, index) => (
                                <th key={index} className="thead-th">
                                    {column}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="tabble-tbody">
                        {data?.map((row, rowIndex) => (
                            <tr key={rowIndex} className="tabble-tr">
                                {columns?.map((column, colIndex) => (
                                    <td key={colIndex} className="tabble-td">{row[column]}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </Container>
    );
};

export default Tabble;
